var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Careers"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4165,
    transform: "translate(-1109 -4103)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6663 7.99992C14.6663 4.31992 11.6797 1.33325 7.99967 1.33325C4.31967 1.33325 1.33301 4.31992 1.33301 7.99992C1.33301 11.2266 3.62634 13.9133 6.66634 14.5333V9.99992H5.33301V7.99992H6.66634V6.33325C6.66634 5.04659 7.71301 3.99992 8.99967 3.99992H10.6663V5.99992H9.33301C8.96634 5.99992 8.66634 6.29992 8.66634 6.66659V7.99992H10.6663V9.99992H8.66634V14.6333C12.033 14.2999 14.6663 11.4599 14.6663 7.99992Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f6935ea80523724d378789ad43a3ae5f.svg";
export { ForwardRef as ReactComponent };